export const CAMERA_STATUS = {
  ERROR: -99,
  WARNING: -1,
  OK: 1,
};

export const CAMERA_AVAILABLE_STATUS = {
  ERROR: -99,
  WARNING: -1,
  OK: 1,
};

export const MODULE_BACK_PATH = 'cameras';

export const APP_STATE = {
  ERROR: -99,
  UNKNOWN: 0,
  IDLE: 1,
  USER_CHOICE: 2,
  PAYMENT: 3,
  PRINT_RECEIPT: 4,
  SERVICE: 5,
};

export const HOST_COMMAND_STATUS = {
  ERROR: -99,
  NOT_SUPPORTED: -4,
  RUNTIME_ERROR: -3,
  OVERDUE: -2,
  CANCELED: -1,
  UNKNOWN: 0,
  WAITING: 1,
  ACCEPTED: 2,
  SUCCESS: 3,
};

export const DEVICE_STATE = {
  ERROR: -99,
  NO_INIT_DETECT_VIOLATION: -3,
  NO_INIT_DETECTION: -2,
  NO_INIT_CAMERA: -1,
  UNKNOWN: 0,
  OK: 1,
};

const deviceMetric = [
  'DEVICE_STATE',
  'PROCESSING',
  'APP_VERSION',
];

export const deviceKeys = [
  'DS_ERROR',
  'DS_NO_INIT_DETECT_VIOLATION',
  'DS_NO_INIT_DETECTION',
  'DS_NO_INIT_CAMERA',
  'DS_UNKNOWN',
  'DS_OK',
];

export const processingKeys = [
  'PRS_NO',
  'PRS_UNKNOWN',
  'PRS_YES',
];

export const cMetricKeys = [
  ...deviceMetric,
];

export const deviceKeysT = {
  DS_ERROR: false,
  DS_NO_INIT_DETECT_VIOLATION: false,
  DS_NO_INIT_DETECTION: false,
  DS_NO_INIT_CAMERA: false,
  DS_UNKNOWN: false,
  DS_OK: false,
};

export const processingKeysT = {
  PRS_NO: false,
  PRS_UNKNOWN: false,
  PRS_YES: false,
};
